import { Button } from '@wot/components';
import React, { useEffect } from 'react';
import { useState } from 'react';

import ReactDOM from 'react-dom';

export const Portal = ({ children }: { children: JSX.Element }) => {
  const [portalDiv, setPortalDiv] = useState<HTMLElement | null>();

  useEffect(() => {
    setPortalDiv(document.getElementById('portal'));
  });
  return portalDiv
    ? ReactDOM.createPortal(<div className="fixed top-0 left-0 w-full min-h-screen z-50">{children}</div>, portalDiv)
    : null;
};

export default function ModalContainer({ children, ModalComp }: { children: JSX.Element; ModalComp: any }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className="cursor-pointer" onClick={() => handleOpen()}>
        {children}
      </div>
      {open && <Modal handleClose={handleClose}>{React.cloneElement(ModalComp, { handleClose: handleClose })}</Modal>}
    </>
  );
}

export function Modal({ children, handleClose }: { children: JSX.Element; handleClose: () => void }) {
  return (
    <Portal>
      {/* <div className="fixed top-0 left-0 w-full min-h-screen z-50"> */}
      <div className="relative w-full h-screen flex justify-center -z-10">
        <div
          onClick={() => {
            handleClose();
          }}
          className="absolute top-0 left-0 w-full h-full bg-black/70 -z-10"
        ></div>
        <div id="portal" className="w-[90%] h-[80%] mx-auto my-auto flex justify-center">
          {children}
        </div>
      </div>
      {/* </div > */}
    </Portal>
  );
}

export function ConfirmationBox({
  text,
  description,
  handleClose,
  onConfirm,
  loading
}: {
  text: string;
  description?: string;
  handleClose?: () => void;
  onConfirm: (closeModal: any) => void;
  loading?: boolean;
}) {
  return (
    <div id="portal" className="w-full h-max max-w-md flex flex-col gap-4 bg-white p-6 rounded-md">
      <h1 id="portal" className="w-full text-xl font-medium text-center">
        {text}
      </h1>
      <p id="portal" className="text-sm">
        {description}
      </p>

      <div id="portal" className="w-full max-w-[200px] flex items-center gap-4 justify-end self-end mt-4">
        <Button text="Confirm" loading={loading} onClick={() => onConfirm(handleClose)} />
        <Button text="Cancel" type="s-outlined" onClick={() => handleClose && handleClose()} />
      </div>
    </div>
  );
}
